/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maintenancedescriptionupcoming2Inputs */



/**
* | output |
* | --- |
* | "We will be conducting maintenance during the specified period. This may result in limitations in the use of the application and even outages. Thank you for y..." |
*
* @param {Maintenancedescriptionupcoming2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const maintenancedescriptionupcoming2 = /** @type {((inputs?: Maintenancedescriptionupcoming2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maintenancedescriptionupcoming2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("We will be conducting maintenance during the specified period. This may result in limitations in the use of the application and even outages. Thank you for your understanding.")
	return /** @type {LocalizedString} */ ("Wir führen in dem angegebenen Zeitraum Wartungsarbeiten durch. Es kann infolgedessen zu Einschränkungen bei der Nutzung der Anwendung und auch zu Ausfällen kommen. Vielen Dank für dein Verständnis.")
});
export { maintenancedescriptionupcoming2 as "maintenanceDescriptionUpcoming" }